var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "union-sync-page" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini", icon: "el-icon-back" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _vm._v(" "),
            _c("h2", [_vm._v("工会数据同步管理")]),
            _vm._v(" "),
            _c("p", [_vm._v("手动同步工会和会员数据，支持全量同步和分页同步")]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-refresh" },
                on: { click: _vm.refreshPage },
              },
              [_vm._v("刷新页面")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("UnionSync", { on: { "sync-completed": _vm.handleSyncCompleted } }),
      _vm._v(" "),
      _c("el-card", { staticClass: "help-card mt20" }, [
        _c("div", { attrs: { slot: "header" }, slot: "header" }, [
          _c("i", { staticClass: "el-icon-question" }),
          _vm._v(" "),
          _c("span", [_vm._v("使用说明")]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "help-content" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("h4", [_vm._v("同步类型说明")]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [
                      _c("strong", [_vm._v("全量同步：")]),
                      _vm._v(
                        "一次性同步所有工会信息和会员数据，适用于首次初始化或定期全面更新"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("strong", [_vm._v("增量同步：")]),
                      _vm._v(
                        "分别同步工会基本信息和会员数据，可独立执行，适用于日常更新"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("strong", [_vm._v("分页同步：")]),
                      _vm._v(
                        "分批次同步数据，适用于大数据量场景，可控制每次同步的数据量"
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("h4", [_vm._v("注意事项")]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [_vm._v("同步过程中请勿关闭页面或重复点击按钮")]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v("大量数据同步可能需要较长时间，请耐心等待"),
                    ]),
                    _vm._v(" "),
                    _c("li", [_vm._v("建议在业务低峰期进行全量同步操作")]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v("如遇到同步失败，请检查网络连接和后端服务状态"),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }